import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import TrendingProductsTable from 'widgets/economy/partials/TrendingProductsTable'

export default function TrendingProductsSmartview ({ product = '' }) {
  return (
    <Translator namespace='smartviews.economy.revenue_by_location'>
      <Translator namespace='economy.trending_products'>
        <Smartview
          tight
          size='sm'
          header={(
            <UI.SecondaryHeading>
              <Translation name={['titles', 'all_' + product].join('.')} />
            </UI.SecondaryHeading>
        )}
        >
          <TrendingProductsTable product={product} limit={null} operationContext={{ context: 'smartview' }} />
        </Smartview>
      </Translator>
    </Translator>
  )
}
